import { render } from "./export-file-instance-modal-content.vue?vue&type=template&id=787a7b0f"
import script from "./export-file-instance-modal-content.vue?vue&type=script&lang=js"
export * from "./export-file-instance-modal-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__